import { Database, Map, FileText, BarChart3, RefreshCw, Shield } from "lucide-react"

const FEATURES = [
  {
    Icon: Database,
    title: "Centralized Inventory",
    desc: "All your mineral rights, leases, and acquisitions in one organized system. No more scattered spreadsheets.",
  },
  {
    Icon: RefreshCw,
    title: "Real-Time Updates",
    desc: "Track sales, acquisitions, trades, and OCC Activity as it happens. Always know exactly what you own.",
  },
  {
    Icon: Map,
    title: "Geographic Insights",
    desc: "Visualize your holdings by county, STR, Operator, etc. for maximum strategic planning",
  },
  {
    Icon: FileText,
    title: "Transaction History",
    desc: "Complete audit trail of every acquisition and disposition with dates, parties, and terms.",
  },
  {
    Icon: BarChart3,
    title: "Portfolio Analytics",
    desc: "Understand your Net Acres, NRI, and Operator exposure at a glance with powerful reporting.",
  },
  {
    Icon: Shield,
    title: "Secure & Reliable",
    desc: "Enterprise-grade security and backups ensure your critical data is always protected.",
  },
]

export function Features() {
  return (
    <section id="features" className="py-24 px-8 lg:px-12 bg-[#111820] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute w-[50%] h-[60%] top-1/2 right-[20%] -translate-y-1/2 bg-[#2E7D4F]/8 rounded-full blur-[120px]" />
      </div>
      <div className="max-w-[1200px] mx-auto relative z-10">
        <div className="text-center mb-16">
          <div className="text-[11px] font-semibold tracking-[0.16em] uppercase text-[#3B9B63] mb-4">
            Features
          </div>
          <h2
            className="text-[clamp(32px,4vw,48px)] font-bold leading-[1.12] text-white mb-5 tracking-[-0.02em]"
            style={{ fontFamily: "'Playfair Display', 'Cormorant Garamond', Georgia, serif" }}
          >
            Built for acquisition teams
            <br />
            who move fast
          </h2>
          <p className="text-[17px] text-white/55 leading-[1.7] font-light max-w-[580px] mx-auto">
            LandTrack gives you the tools to stay organized and make confident decisions when every
            minute counts.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {FEATURES.map(({ Icon, title, desc }) => (
            <div
              key={title}
              className="bg-[#1A2332] border border-white/[0.08] rounded-xl p-8 hover:border-[#2E7D4F]/30 transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-[#2E7D4F]/15 border border-[#2E7D4F]/25 rounded-lg flex items-center justify-center mb-5 group-hover:bg-[#2E7D4F]/25 transition-colors">
                <Icon className="w-5 h-5 text-[#3B9B63]" strokeWidth={1.8} />
              </div>
              <h3 className="text-[15px] font-semibold text-white/90 mb-3 leading-[1.3]">
                {title}
              </h3>
              <p className="text-[14px] text-white/45 leading-[1.65] font-light">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
